
import React from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

/**
 * Helper component to safely render children.
 * If an error occurs during rendering, it shows a fallback UI
 * instead of crashing the whole page.
 */
function SafeWrapper({ children }: { children: React.ReactNode }) {
  try {
    return <>{children}</>;
  } catch (error) {
    console.error('Rendering error:', error);
    return (
      <div className="p-4 text-center text-red-600">
        Something went wrong while loading this section.
      </div>
    );
  }
}

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-white">
      <SafeWrapper>
        <Navbar />
      </SafeWrapper>

      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center">
        <div className="absolute inset-0">
          <img
            src="https://static.readdy.ai/image/ad65b144d099927d3f1598dca8778b1e/3ad132eacdef038b584b493d3ed742b0.jpeg"
            alt="Contact Hero"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        </div>

        <div className="relative z-10 text-center px-6">
          <h1 className="text-5xl md:text-6xl font-light text-white tracking-tight">
            Get in Touch
          </h1>
        </div>
      </section>

      {/* Contact Content */}
      <section className="py-24 px-6">
        <div className="max-w-2xl mx-auto text-center">
          <div className="mb-10">
            <p className="text-sm text-gray-500 uppercase tracking-widest mb-3">
              Email
            </p>
            <a
              href="mailto:pamela@pamelastovall.com"
              className="text-2xl text-black hover:text-gray-600 transition-colors cursor-pointer"
            >
              pamela@pamelastovall.com
            </a>
          </div>

          <a
            href="mailto:pamela@pamelastovall.com?subject=Hello%20Pamela"
            className="inline-flex items-center gap-3 px-8 py-4 bg-black text-white text-sm font-medium tracking-wide hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-mail-line text-lg"></i>
            </span>
            Send Me an Email
          </a>
        </div>
      </section>

      <SafeWrapper>
        <Footer />
      </SafeWrapper>
    </div>
  );
}
